import { useTranslation } from "react-i18next";
import React from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import { Link, withRouter } from 'react-router-dom';
import Layout from 'Components/Layout';
import Page404 from 'Pages/Page404';
import Verification from 'Components/Personal/Property/Verification';

function OneProperty({
  property
}) {
  const {
    t
  } = useTranslation();

  if (!property) {
    return <Page404 />;
  }

  return <Layout>
      <Helmet>
        <title>{t("Manage Property - HeresMyInfo.com")}</title>
      </Helmet>
      <Container>
        <h3><Link to='/personal'>{'<<'}{t("Back to Profile data")}</Link></h3>
        <Verification property={property} />
      </Container>
    </Layout>;
}

const mapStateToProps = (state, ownProps) => ({
  property: state.auth.currentUser.profile.properties.find(property => property.objectId === ownProps.match.params.propertyId)
});

export default withRouter(connect(mapStateToProps)(OneProperty));